// The API sends every event name twice: the site's primary-language (German-
// first) one, and an English-first one (<name>EN). Picks the one matching the
// visitor's language setting (intl.locale / useLanguage().language), falling
// back to whichever exists.
export const eventNameFor = (locale, name, nameEN) =>
  (locale || '').startsWith('en') ? (nameEN || name) : (name || nameEN);
